import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bookCollectionService } from '../../../../service/BookCollectionService'
import { showErrorToast, showSuccessToast, showDeleteToast, toastKey } from '../../../../utils/showToast'
import { bookPackageKeys } from '../../../../data/queryFactories'

export default function useDeleteBookPackageByUuid() {
  const queryClient = useQueryClient()
  const deleteBookPackageByUuidMutation = useMutation({
    mutationFn: async (uuid) => {
      if (!uuid) {
        showErrorToast({
          message: 'Vui lòng nhập đủ thông tin',
          toastId: toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET,
        })
        return
      }
      return await bookCollectionService.deleteByUuid({ uuid })
    },
    onError(error) {
      showErrorToast({
        error:  error.message,
        message: 'Xoá dữ liệu thất bại',
        toastId: toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET,
      })
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: bookPackageKeys.all })
      showDeleteToast('Xoá dữ liệu thành công', toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET)
       },
  })
  return { deleteBookPackageByUuidMutation }
}
